import request from '@/utils/request'

// 待发货列表
export function fetchList(data) {
	return request({
		url: '/oms/order/selectOmsOrderInfoList',
		method: 'post',
		data
	})
}

// 到货单详情
export function getOrderDetail(id) {
	return request({
		url: `/oms/omsOrder/${id}`,
		method: 'get'
	})
}

// 订单详情
export function getOrderDetailByOrderSn(data) {
	return request({
		url: `/oms/omsOrder/orderSn/${data.orderSn}`,
		method: 'get',
		params: data,
	})
}

export function getOrderSku(orderSn) {
	return request({
		url: `/oms/omsOrder/orderSn/${orderSn}`,
		method: 'get'
	})
}

// 打印拣货单
export function printOrderDelivery(data) {
	return request({
		url: '/oms/omsOrder/printOrderDelivery',
		method: 'post',
		params: data
	})
}

//打印唛头
export function printMark(orderIds) {
	return request({
		url: '/oms/omsOrder/printMark?orderIds=' + orderIds,
		method: 'get',
	})
}

//打印Package Number
export function printPackageNumber(orderIds) {
	return request({
		url: '/oms/omsOrder/printPackageNumber?orderIds=' + orderIds,
		method: 'get',
	})
}

// 打印面单
export function printDeliveryorder(id) {
	let url = `/oms/omsOrder/printDeliveryOrder/${id}`;
	return request({
		url: url,
		method: 'get'
	})
}

// 补打面单
export function rePrintDeliveryorder(orderSn) {
	return request({
		url: `/oms/order/getExpressInfo?orderSn=${orderSn}`,
		method: 'get'
	})
}

// 保存包裹重量
export function saveOrderWeight(data) {
	return request({
		url: '/oms/omsOrder/saveOrderWeight',
		method: 'post',
		data: data
	})
}

//提交订单备注
export function orderRemark(data) {
	return request({
		url: '/oms/order/remark',
		method: 'post',
		data: data
	})
}

//确认装箱包裹信息
export function confirmPackage(data) {
	return request({
		url: '/oms/order/confirmPackage',
		method: 'post',
		data: data
	})
}

//修改商品数量
export function updateGoodsNum(data){
	return request({
		url: '/oms/order/updateGoodsNum',
		method: 'post',
		data: data
	})
}

//下载订单发票
export function downloadInvoice(orderSn) {
	return request({
		url: '/oms/order/downloadInvoice?orderSn=' + orderSn,
		method: 'get',
		responseType: 'blob',
	})
}

//平台订单重新配货
export function rematch(data){
	return request({
		url: '/oms/order/rematch',
		method: 'post',
		data: data
	})
}

//平台订单转远期单
export function outDelivery(data){
	return request({
		url: '/oms/order/outDelivery',
		method: 'post',
		data: data
	})
}

// 状态字典
export function orderDictList(data) {
	return request({
		url: '/oms/orderDict/list',
		method: 'get',
		params: data
	})
}

// 到仓签收  sn sn为DHD打头的到货单号
export function orderReceived(data) {
	return request({
		url: '/scm/deliverOrder/received',
		method: 'post',
		data: data
	})
}

//货运信息导入
export function importForwarderCost(data) {
	return request({
		url: '/oms/order/forwarderCost/import',
		method: 'post',
		data: data
	})
}

//下载货运信息导入模板
export function downloadFrightTemplate(){
	return request({
		url: '/oms/order/freight/template',
		method: 'GET',
		responseType: 'blob'
	})
}

//下载订单导入模板
export function downloadTemplate(){
	return request({
		url: '/oms/order/import/template',
		method: 'GET',
		responseType: 'blob'
	})
}

export function receivedOrder(data) {
	return request({
		url: '/oms/order/received',
		method: 'get',
		params: data
	})
}

export function fulfilldOrder(data) {
	return request({
		url: '/oms/order/fulfill',
		method: 'get',
		params: data
	})
}

export function smartReturnOrder(data) {
	return request({
		url: '/oms/order/smart/return',
		method: 'get',
		params: data
	})
}

//字典模糊查询
export function dict(key, query){
	return request({
		url: '/oms/orderDict/listByKey',
		method: 'get',
		params: {key, query}
	})
}



// WEBPACK FOOTER //
// ./src/api/sms/forwarding-order.js